module.exports = __webpack_public_path__ + "img/brands-wasa-madre.jpg?3daed1c6a4d55704262de071cd8ee79b";